import { theme } from '@prose-ui';
import { keyframes, legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

import { ReactComponent as ArrowSVG } from 'assets/images/landingPages/supplements/supplements_hero_arrow.svg';

export const Content = styled.div`
  ${legacyTheme.breakpoints.up('md')} {
    max-width: 570px;
  }

  & a {
    margin: 0;
  }
`;

export const Title = styled(Typography)`
  position: relative;

  width: fit-content;
  margin-bottom: 8px;

  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;

  ${legacyTheme.breakpoints.up('sm')} {
    margin-bottom: 16px;
    font-size: 16px;

    span {
      position: absolute;
      top: -4px;
      font-size: 10px;
    }
  }

  ${legacyTheme.breakpoints.up('md')} {
    margin-bottom: 24px;
  }
`;

export const Paragraph = styled(Typography)`
  margin-bottom: 30px;

  font-size: 36px;
  line-height: 1.22;
  letter-spacing: 0.25px;

  & b {
    font-weight: 500;
  }

  & #hero-title-1 {
    position: relative;
    margin-right: 15px;
  }

  & #hero-title-2 {
    position: relative;
    width: fit-content;
  }

  & #hero-title-1 sup {
    top: -1.5em;
    font-size: 31%;
  }

  & #hero-title-1::after {
    content: 'TM';
    position: absolute;
    bottom: 23px;
    font-size: 11px;
  }

  & #hero-title-2::after {
    content: '*';

    position: absolute;
    top: 10px;
    right: -14px;

    font-size: 20px;
  }

  ${legacyTheme.breakpoints.up('sm')} {
    margin-bottom: 32px;
    font-size: 60px;
    line-height: 1.13;
    letter-spacing: normal;

    & #hero-title-1 {
      margin-right: 0;
    }

    & #hero-title-1::after {
      bottom: 36px;
      font-size: 20px;
    }

    & #hero-title-1::after {
      display: none;
    }

    & #hero-title-2::after {
      top: 12px;
      right: -23px;
      font-size: 40px;
    }
  }

  ${legacyTheme.breakpoints.up('md')} {
    font-size: 80px;

    & span {
      display: block;
    }

    & #hero-title-1::after {
      top: 10px;
      font-size: 25px;
    }
  }
`;

export const ArrowWrapper = styled.div`
  position: absolute;
  bottom: 6vh;
  left: 23.5px;

  ${legacyTheme.breakpoints.up('sm')} {
    left: 72px;
  }

  ${legacyTheme.breakpoints.up('md')} {
    left: 136px;
  }

  & svg g {
    stroke: ${theme.colors.supps[200]};

    ${legacyTheme.breakpoints.up('sm')} {
      stroke: ${theme.colors.supps[100]};
    }
  }
`;

const bounce = keyframes`
  from, to {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(25%);
  }
`;

export const Arrow = styled(ArrowSVG)`
  animation: ${bounce} 1s ease-in-out infinite;
`;
